// TinyMCE Rich Text Editor Controller
export class TinyMCEController {
  static initialize() {
    console.log("TinyMCE controller initializing...");

    // Initialize on DOM ready
    document.addEventListener("DOMContentLoaded", () => {
      console.log("DOM loaded, initializing TinyMCE");
      TinyMCEController.initTinyMCE();
    });

    // Initialize on Turbolinks navigation
    document.addEventListener("turbolinks:load", () => {
      console.log("Turbolinks load, initializing TinyMCE");
      TinyMCEController.initTinyMCE();
    });
  }

  static initTinyMCE() {
    // Check if TinyMCE is loaded
    if (typeof tinymce === "undefined") {
      console.error("TinyMCE is not loaded");
      return;
    }

    // Remove existing TinyMCE instances
    tinymce.remove(".tinymce");

    // Check if there are any textareas with tinymce class
    const tinymceTextareas = document.querySelectorAll(".tinymce");
    if (tinymceTextareas.length === 0) {
      console.log("No TinyMCE textareas found");
      return;
    }

    console.log(
      "Initializing TinyMCE for",
      tinymceTextareas.length,
      "textareas"
    );

    // Small delay to ensure DOM is fully ready
    const selfHosted = window.TINYMCE_SELF_HOSTED === true;
    setTimeout(() => {
      tinymce.init({
        selector: ".tinymce",
        ...(selfHosted && {
          license_key: "gpl",
          base_url: "https://cdn.jsdelivr.net/npm/tinymce@7",
          suffix: ".min",
        }),
        height: 250,
        menubar: false,
        toolbar:
          "undo redo | bold italic underline | bullist numlist | link | removeformat",
        plugins: "autolink link lists paste wordcount",
        valid_elements: "p,strong,em,u,a[href],ul,ol,li,br",
        forced_root_block: "p",
        target_list: false,
        link_title: false,
        link_assume_external_targets: "https",
        relative_urls: false,
        remove_script_host: false,
        paste_as_text: true,
        content_style:
          'body { font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif; font-size: 14px; }',
        statusbar: false,
        elementpath: false,
        init_instance_callback: (editor) => {
          console.log("TinyMCE initialized for:", editor.id);
          // Ensure content is loaded from the textarea
          const textarea = document.getElementById(editor.id);
          if (textarea && textarea.value) {
            console.log(
              "Loading existing content for:",
              editor.id,
              textarea.value.substring(0, 50) + "..."
            );
            editor.setContent(textarea.value);
          } else {
            console.log("No existing content found for:", editor.id);
          }
        },
        setup: (editor) => {
          editor.on("change keyup", () => {
            editor.save();
          });

          editor.on("init", () => {
            // Force content reload after initialization
            const textarea = document.getElementById(editor.id);
            if (textarea && textarea.value) {
              console.log("Force loading content on init for:", editor.id);
              editor.setContent(textarea.value);
            }
          });
        },
      });
    }, 100);
  }
}

// Auto-initialize when module is loaded
TinyMCEController.initialize();
